'use client';

import { Button } from '../../../components/button';
import type { ChatSuggestionPromptRowProps } from './types';

export function ChatSuggestionPromptRow({
  promptText,
  isLast,
  onPromptClick,
}: ChatSuggestionPromptRowProps) {
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      onClick={() => onPromptClick(promptText)}
      justifyContent="flex-start"
      textAlign="left"
      w="full"
      h="auto"
      py={3}
      px={3}
      fontSize="sm"
      fontWeight="normal"
      whiteSpace="normal"
      borderRadius={0}
      borderBottomWidth={isLast ? 0 : '1px'}
      borderBottomColor="border.muted"
      aria-label={promptText}
    >
      {promptText}
    </Button>
  );
}
